import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import PromotionReviewItem from './PromotionReviewItem';

const PromotionReviewsGallery = ({
  categoryId,
  categoryName,
  closedReviews,
  totalReviews,
  reviews,
}) => {
  const onReviewSelected = (index) => {
    console.log(`onItemSelected${index}`);
  };

  if (reviews.length > 0) {
    return (
      <Fragment>
        <div className="promotion-review-gallery-type">
          <span>{categoryName}</span>
          <div className="closed-reviews">{closedReviews} / {totalReviews} revisiones consumidas</div>
        </div>
        <div className="promotion-review-items">
          {reviews.map((review, index) => (
            <PromotionReviewItem
              categoryId={categoryId}
              categoryName={categoryName}
              review={review}
              onReviewSelected={() => onReviewSelected(index)}
            />
          ))}

        </div>
      </Fragment>
    );
  }

  return null;
};

PromotionReviewsGallery.propTypes = {
  categoryId: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  closedReviews: PropTypes.number.isRequired,
  totalReviews: PropTypes.number.isRequired,
  reviews: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    isFinal: PropTypes.bool,
  })).isRequired,
};
export default PromotionReviewsGallery;
